<template>
    <div ref="scrollRef">
        <img :src="require('@/assets/img/products/banner.png')" alt="" style="width: 100%" data-aos="zoom-out">
        <div class="introduce" data-aos="flip-down">
            <div>
                <div v-for="(item,index) in introduceList" @click="introduceListHover(item.id)" :class="index===1?'active':''"
                     :style="{
                        'border-left':active===0?'none':active===1?'none':'1px solid #e6e6e6',
                        'border-right':active===2?'none':'1px solid #e6e6e6',
                     }"
                >
                    <img :src="require('@/assets/img/products/'+item.img+'.png')" alt="" >
                    <div v-html="item.title"></div>
                </div>
            </div>
        </div>
        <router-view @productsSelect="productsSelect"></router-view>
<!--        <ProductsMenu @productsSelect="productsSelect"/>-->
    </div>
</template>

<script>
// import ProductsMenu from "../components/ProductsMenu";
export default {
	components: {
	    // ProductsMenu
    },
	data() {
		return {
		  introduceList:[
              {
                  title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                  img:'introduce1',
                  id:0
              },
              {
                  title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                  img:'introduce2',
                  id:1
              },
              {
                  title:'EH-ILS实验室<br>整体规划设计解决方案',
                  img:'introduce3',
                  id:2
              },
          ],
          active:1,
          activeList:[
              {
                  active:0,
                  link:['eCell','cellData','screen','stomer','cellMonitor','cellCloud','cellVision','aabb','gmp','cellEquipment','cellVenue','cellDownload']
              },
              {
                  active:1,
                  link:['tissueBank','specialBank','dataCollection','transport','share','bioCohort','bioVision','queue','training','equipment','venue','service','download']
              },
              {
                  active:2,
                  link:['eQuip','proHazard','iLab','aniManus','iMonitor','enViron','labVison','iso15189','cnas','glp','limsEquipment','limsVenue','download']
              }
          ]
        }
	},
	mounted(){
        this.$nextTick(()=>{
            for (let i=0;i<this.activeList.length;i++){
                for (let j=0;j<this.activeList[i].link.length;j++){
                    if (this.$route.path.indexOf(this.activeList[i].link[j]) > 0){
                            this.active = this.activeList[i].active
                            if(this.activeList[i].active===0){
                                this.introduceList = [
                                  {
                                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                                      img:'introduce2',
                                      id:1
                                  },
                                  {
                                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                                      img:'introduce1',
                                      id:0
                                  },
                                  {
                                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                                      img:'introduce3',
                                      id:2
                                  },
                                ]
                            }else if(this.activeList[i].active === 1){
                                this.introduceList = [
                                  {
                                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                                      img:'introduce1',
                                      id:0
                                  },
                                  {
                                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                                      img:'introduce2',
                                      id:1
                                  },
                                  {
                                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                                      img:'introduce3',
                                      id:2
                                  },
                                ]
                            }else if(this.activeList[i].active === 2){
                                this.introduceList = [
                                  {
                                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                                      img:'introduce1',
                                      id:0
                                  },
                                  {
                                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                                      img:'introduce3',
                                      id:2
                                  },
                                  {
                                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                                      img:'introduce2',
                                      id:1
                                  },
                                ]
                            }
                            return
                    }
                }
            }
        })
	},
    watch:{
        $route(to,from) {
            this.$nextTick(()=>{
                for (let i=0;i<this.activeList.length;i++){
                    for (let j=0;j<this.activeList[i].link.length;j++){
                        if (to.path.indexOf(this.activeList[i].link[j]) > 0){
                            this.active = this.activeList[i].active
                            if(this.activeList[i].active===0){
                                this.introduceList = [
                                  {
                                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                                      img:'introduce2',
                                      id:1
                                  },
                                  {
                                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                                      img:'introduce1',
                                      id:0
                                  },
                                  {
                                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                                      img:'introduce3',
                                      id:2
                                  },
                                ]
                            }else if(this.activeList[i].active === 1){
                                this.introduceList = [
                                  {
                                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                                      img:'introduce1',
                                      id:0
                                  },
                                  {
                                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                                      img:'introduce2',
                                      id:1
                                  },
                                  {
                                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                                      img:'introduce3',
                                      id:2
                                  },
                                ]
                            }else if(this.activeList[i].active === 2){
                                this.introduceList = [
                                  {
                                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                                      img:'introduce1',
                                      id:0
                                  },
                                  {
                                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                                      img:'introduce3',
                                      id:2
                                  },
                                  {
                                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                                      img:'introduce2',
                                      id:1
                                  },
                                ]
                            }
                            return
                        }
                    }
                }
            })

        }
      },
    methods:{
	    productsSelect(src){
	        if (src.indexOf('/img') > -1){
	            return
            }
            this.$router.push({
                path:src
            })
        },
        introduceListHover(index){
	        this.active = index
            if(index===0){
                this.introduceList = [
                  {
                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                      img:'introduce2',
                      id:1
                  },
                  {
                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                      img:'introduce1',
                      id:0
                  },
                  {
                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                      img:'introduce3',
                      id:2
                  },
                ]
                this.$router.push({
                    path:'/products/eCell'
                })
            }else if(index === 1){
                this.introduceList = [
                  {
                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                      img:'introduce1',
                      id:0
                  },
                  {
                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                      img:'introduce2',
                      id:1
                  },
                  {
                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                      img:'introduce3',
                      id:2
                  },
                ]
                this.$router.push({
                    path:'/products/qxzn'
                })
            }else if(index === 2){
                this.introduceList = [
                  {
                      title:'EH-CLCMS细胞<br>全生命周期整体解决方案',
                      img:'introduce1',
                      id:0
                  },
                  {
                      title:'EH-ILS实验室<br>整体规划设计解决方案',
                      img:'introduce3',
                      id:2
                  },
                  {
                      title:'EH-IBS生物样本库<br>数字化智能全息解决方案',
                      img:'introduce2',
                      id:1
                  },
                ]
                this.$router.push({
                    path:'/products/iLab'
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .introduce{
        width: 100%;
        height: 230px;
        padding: 30px 0;
        box-sizing: border-box;
        box-shadow: 0 3px 10px rgba(51, 51, 51, 0.26);
        &>div{
            width: 1145px;
            height: 182px;
            margin: 0 auto;
            box-sizing: border-box;
            border-left: 1px solid #e6e6e6;
            border-right: 1px solid #e6e6e6;
            display: flex;
            justify-content: space-between;
            position: relative;
            &>div{
                width: 360px;
                height: 100%;
                text-align: center;
                box-sizing: border-box;
                padding-top: 15px;
                font-size: 22px;
                letter-spacing: 4px;
                cursor: pointer;
                div{
                    margin-top: 15px;
                }
            }
            .active{
                width: 424px;
                height: 250px;
                /*position: absolute;*/
                /*top: -40px;*/
                /*left: 360px;*/
                margin-top: -42px;
                background: url("../assets/img/products/introduceBg.png") 100% 100%;
                padding-top: 44px;
                box-sizing: border-box;
                box-shadow:rgba(51, 51, 51, 0.8) 0px 0px 10px ;
                position: relative;
                div{
                    /*color: #fff;*/
                    line-height: 40px;
                }

            }
        }
    }
</style>
